import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import {
	Component,
	OnInit,
	ElementRef,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	HostListener,
	ViewRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatMenuTrigger } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap } from 'rxjs/operators';
import { merge, BehaviorSubject } from 'rxjs';
//Datasource
import { ThongTinHangVeDataSource } from '../phieu-thong-tin-hang-ve-ver2-datasource/phieu-thong-tin-hang-ve-ver2.datasource';
//Service
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-ver2-service/phieu-thong-tin-hang-ve-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
//Model
import { DeNghiNhapKho } from '../phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
//Component
import { ThongTinHangVeAddEditVer2Component } from '../phieu-thong-tin-hang-ve-ver2-add-edit/phieu-thong-tin-hang-ve-ver2-add-edit.component';
import { KeHoachHangVeTTHVService } from '../ke-hoach-hang-ve-service/ke-hoach-hang-ve.service';
import { PhieuKiemTraComponent } from '../kiem-tra-hang/kiem-tra-hang.component';
import { PhieuThongTinHangVeDetailComponent } from '../phieu-thong-tin-hang-ve-ver2-detail/phieu-thong-tin-hang-ve-ver2-detail.component';
import { DuyetKQKiemTraHangComponent } from '../duyet-kq-kiem-tra-hang/duyet-kq-kiem-tra-hang.component'
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { GDDuyetKQKiemTraHangComponent } from '../gd-duyet-kq-kiem-tra-hang/gd-duyet-kq-kiem-tra-hang.component';

@Component({
	selector: 'm-phieu-thong-tin-hang-ve-ver2-list',
	templateUrl: './phieu-thong-tin-hang-ve-ver2-list.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class ThongTinHangVeListV2Component implements OnInit {

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('sort1', { static: true }) sort: MatSort;
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;
	@ViewChild("keywordsearch", { static: true }) keywordsearch: ElementRef;


	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/
	

	/*--------------------Comment columns mat-table----------------------*/
	dataSource: ThongTinHangVeDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'Sophieu',
			displayName: 'Số phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'Ngaynhap',
			displayName: 'Ngày lập phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'TenNguoitao',
			displayName: 'Người lập phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'TenTinhTrang',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKho>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ----------------------------- Filter ------------------------------*/
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	deNghiNhapKhoResult: DeNghiNhapKho[] = [];
	tmpDeNghiNhapKhoResult: DeNghiNhapKho[] = [];
	/* ------------------------------------------------------------------ */


	/* ------------------------------ ROLE ------------------------------*/
	TAO = 131;
	HUY = 208;
	LIST_ROLES_USER: [] = [];
	SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);
	SHOW_BUTTON_REMOVE = new BehaviorSubject<boolean>(false);
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;
	previousIndex: number;
	fixedPoint = 2;
	isClearAll: boolean = false;
	openDialog: boolean = false;
	optionsTinhTrang = [];
	/* ------------------------------------------------------------------ */


	/* --------------------------- Qui trình -----------------------------*/
	numOfCheckVisible: any[] = [];
	CoQuyen: string = '0';
	/* ------------------------------------------------------------------ */

	constructor(
		private thongTinHangVeService: ThongTinHangVeService,
		private keHoachHangVeService: KeHoachHangVeTTHVService,
		public dialog: MatDialog,
		private router: Router,
		private datePipe: DatePipe,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private tokenStorage: TokenStorage,
		private dungChungService : DungChungService
	) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
	}


	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.optionsTinhTrang = DeNghiNhapKho.optionsTinhTrang;

		this.haveFilter = true;
		this.tmpfilterText = Object.assign({}, this.filterText);

		this.disableButtonFilter['Tinhtrang'] = true;
		this.disableButtonFilter['SoPhieu'] = true;
		this.disableButtonFilter['TenNguoiTao'] = true;

		
		this.filterGroupDataChecked['SoPhieu'] = '';
		this.filterGroupDataChecked['TenNguoiTao'] = '';
		this.filterGroupDataChecked['Tinhtrang'] = this.optionsTinhTrang.map(x => {
			return {
				id: x.id,
				name: x.name,
				value: x.value,
				checked: false
			}
		});
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.showColumnsInTable();
		this.applySelectedColumns();

		this.SHOW_BUTTON_CREATE.next(this.isTrueButton(this.TAO));
		this.SHOW_BUTTON_REMOVE.next(this.isTrueButton(this.HUY));
	
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadTTHangVeListWithoutPageChange(false);
					this.forcusEvents();
				})
			)
			.subscribe();


		// // Set title to page breadCrumbs
		let breadcrumbs = [{ title: 'Kho' }, { title: 'Thông tin hàng về', page: '/phieu-thong-tin-hang-ve' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		// Init DataSource
		this.dataSource = new ThongTinHangVeDataSource(this.thongTinHangVeService);
		let queryParams = new QueryParamsModel({});

		this.dataSource.entitySubject.subscribe(res => {
			this.deNghiNhapKhoResult = res
			this.tmpDeNghiNhapKhoResult = []
			if (this.deNghiNhapKhoResult != null && this.deNghiNhapKhoResult.length > 0) {
				for (let i = 0; i < this.deNghiNhapKhoResult.length; i++) {
					let setPrio = [];
					for(let j = 0; j < this.deNghiNhapKhoResult[i].Data_Duyet.length; j++){
						if(setPrio.findIndex(x => x == this.deNghiNhapKhoResult[i].Data_Duyet[j].Priority) == -1){
							setPrio.push(this.deNghiNhapKhoResult[i].Data_Duyet[j].Priority)
						}
					}
					this.numOfCheckVisible.push(
						[
							{
								priority: setPrio[0],
								value: 0,
								index:-1
							},
							{
								priority: setPrio[1],
								value: 0,
								index:-1
							},
							{
								priority: setPrio[2],
								value: 0,
								index:-1
							}
						]
					);
					let tmpElement = new DeNghiNhapKho();
					tmpElement.copy(this.deNghiNhapKhoResult[i])
					this.tmpDeNghiNhapKhoResult.push(tmpElement);
				}
			}
		});
		this.loadTTHangVeList();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
	}
	loadTTHangVeListWithoutPageChange(isDeleteAction: boolean) {
		this.selection.clear();
		let moveToPreviousPage = this.deNghiNhapKhoResult.length == 1 && this.paginator.pageIndex > 0 ? true : false;
		if(moveToPreviousPage)
			this.paginator.pageIndex = this.paginator.pageIndex - 1
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadThongTinHangVes(queryParams);
	}
	loadTTHangVeList() {
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadThongTinHangVes(queryParams);
	}
	filterConfiguration(): any {
		const filter: any = {};
		filter.CoQuyen = this.CoQuyen;
		filter.keywordsearch = this.keywordsearch.nativeElement.value;
		return filter;
		
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- CÁC THAO TÁC TRÊN FORM ----------------------*/
	addPhieuThongTinHangVe() {
		const newPhieuThongTinHangVe = new DeNghiNhapKho();
		newPhieuThongTinHangVe.clear(); // Set all defaults fields
		newPhieuThongTinHangVe.Tinhtrang = this.optionsTinhTrang[0].value;
		this.editPhieuThongTinHangVe(newPhieuThongTinHangVe);
	}
	editPhieuThongTinHangVe(item: DeNghiNhapKho) {
		if(this.checkDashboardRoute())	return null;

		if (item.IdDn > 0) {
			this.thongTinHangVeService.getThongTinHangVeDetail(item).subscribe(res => {
				if (res.status == 1) {
					item = res.data;
					const dialogRef = this.dialog.open(ThongTinHangVeAddEditVer2Component, {
						data: {
							data: item,
							selected: [],
							dataDSKH: []
						},
						width: '90vw',
					});

					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();
						if (res == undefined || res == null) {
							return;
						}
						else {
							if (!res.isChange) {
								return;
							}
							if (res.PTTHVNew.length != 0) {
								this.saveNewTTHV = res.PTTHVNew;
							}
							let listDataAdd = res.dataAdd
							if (listDataAdd != null && listDataAdd.length > 0) {
								listDataAdd.forEach(element => { this.keHoachHangVeService.updateKeHoachHangVe(element).subscribe(res => {})})
							}
							this.loadTTHangVeListWithoutPageChange(false);
						}
					});
				}
				else{
					this.forcusEvents();
				}
			});
		}
		else {
			this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
				if (res.status == 1) {
					item.Sophieu = res.data;
					const dialogRef = this.dialog.open(ThongTinHangVeAddEditVer2Component, {
						data: {
							data: item,
							selected: [],
							dataDSKH: []
						},
						maxHeight: '90vh',
						width: '90vw',
					});

					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();
						if (res == undefined || res == null) {
							return;
						}
						else {
							if (!res.isChange) {
								return;
							}
							if (res.PTTHVNew.length != 0) {
								this.saveNewTTHV = res.PTTHVNew;
							}
							let listDataAdd = res.dataAdd
							if (listDataAdd != null && listDataAdd.length > 0) {
								listDataAdd.forEach(element => {this.keHoachHangVeService.updateKeHoachHangVe(element).subscribe(res => {})})
							}
							this.loadTTHangVeList();
						}
					});
				}
				else {
					const message = `Lỗi lấy số phiếu tiếp theo`;
					this.forcusEvents();
					this.layoutUtilsService.showErorr(message);
				}
			});
		}
	}
	detailPhieuDeNghiMuaHang(item: DeNghiNhapKho) {
		if (this.checkDashboardRoute()) return null;
		this.thongTinHangVeService.getThongTinHangVeDetail(item).subscribe(res => {
			if (res.status == 1) {
				item = res.data;
				const dialogRef = this.dialog.open(PhieuThongTinHangVeDetailComponent, {
					data: {
						data: item,
						selected: [],
						dataDSKH: []
					},
					maxHeight: '90vh',
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.forcusEvents();
				});
			}
			else {
				this.forcusEvents();
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	deletePhieuThongTinHangVe(item: DeNghiNhapKho) {
		if(this.checkDashboardRoute())	return null;
		const dialogRef = this.layoutUtilsService.POP01(item.Sophieu);
		const _deleteMessage = `Phiếu đã được xóa`;
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.thongTinHangVeService.deleteThongTinHangVe(item.IdDn).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
				this.loadTTHangVeListWithoutPageChange(true);
			});
		});
	}
	cancelTrangThaiPhieu(item: DeNghiNhapKho) {
		if(this.checkDashboardRoute())	return null;
		this.thongTinHangVeService.checkCancelThongTinHangVe(item.IdDn).subscribe(res => {
			if (res && res.status === 1) {
				const dialogRef = this.layoutUtilsService.POP04(item.Sophieu);
				const _deleteMessage = `Phiếu đã được hủy`;
				dialogRef.afterClosed().subscribe(res => {
					if (!res) {
						return;
					}
					this.thongTinHangVeService.huyThongTinHangVe(item).subscribe(res => {
						if (res && res.status === 1) {
							this.layoutUtilsService.showInfo(_deleteMessage);
							this.saveNewTTHV = [];
							this.saveNewTTHV.push(item.IdDn);
						}
						else {
							this.layoutUtilsService.showErorr(res.error.message);
						}
						this.loadTTHangVeListWithoutPageChange(false);
					});
				});
			}
			else {
				this.forcusEvents();
				this.layoutUtilsService.showErorr("Phiếu đang thực hiện kiểm tra pass hàng. Bạn không được hủy");
			}
		});
	}
	checkPhieuDeNghiMuaHang(item: DeNghiNhapKho) {
		if (this.checkDashboardRoute()) return null;
		this.thongTinHangVeService.getThongTinHangVeDetail(item).subscribe(res => {
			if (res.status == 1) {
				
				item = res.data;
				const dialogRef = this.dialog.open(PhieuKiemTraComponent, {
					data: {
						data: item,						
						selected: [],
						dataDSKH: []
					},
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					// this.forcusEvents();
					
					if (res == undefined || res == null) {
						return;
					}
					else {
					
						if (res.PTTHVNew.length > 0) {
							this.saveNewTTHV = res.PTTHVNew;
						}
						this.loadTTHangVeListWithoutPageChange(false);
					}
				});
			}
		});
	}
	duyetPhieuDeNghiMuaHang(item: DeNghiNhapKho) {
		if (this.checkDashboardRoute()) return null;
		this.thongTinHangVeService.getThongTinHangVeDetail(item).subscribe(res => {
			if (res.status == 1) {
				
				item = res.data;
				const dialogRef = this.dialog.open(DuyetKQKiemTraHangComponent, {
					data: {
						data: item,
						selected: [],
						dataDSKH: []
					},
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.forcusEvents();
					if (res == undefined || res == null) {
						return;
					}
					else {
						if (!res.isChange) {
							return;
						}
						this.saveNewTTHV = [];
						this.saveNewTTHV.push(item.IdDn);
						this.loadTTHangVeListWithoutPageChange(false);
					}
				});
			}
		});
	}
	GDduyetPhieuDeNghiMuaHang(item: DeNghiNhapKho) {
		if (this.checkDashboardRoute()) return null;
		this.thongTinHangVeService.getThongTinHangVeDetail(item).subscribe(res => {
			if (res.status == 1) {
			
				item = res.data;
				const dialogRef = this.dialog.open(GDDuyetKQKiemTraHangComponent, {
					data: {
						data: item,
						selected: [],
						dataDSKH: []
					},
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.forcusEvents();
					if (res == undefined || res == null) {
						return;
					}
					else {
						if (!res.isChange) {
							return;
						}
						this.saveNewTTHV = [];
						this.saveNewTTHV.push(item.IdDn);
						this.loadTTHangVeListWithoutPageChange(false);
					}
				});
			}
		});
	}
	xuLy(ph: DeNghiNhapKho, priority: number) {
		
		if (ph.Tinhtrang == this.optionsTinhTrang[1].value && priority == 1) {
			this.checkPhieuDeNghiMuaHang(ph);
		}
		else if(ph.Tinhtrang == this.optionsTinhTrang[1].value && priority == 2){
			this.duyetPhieuDeNghiMuaHang(ph);
		}
		else if(ph.Tinhtrang == this.optionsTinhTrang[1].value && priority == 3){
			this.GDduyetPhieuDeNghiMuaHang(ph);
		}
	}
	checkVisibleButton(data: any, index: number, indexDataDuyet:number, priority: number){
		let listCheck = data.filter(x => x.Priority == priority);
		if(listCheck != null){
			let tmpArray = [];
			let filter = this.numOfCheckVisible[index].findIndex(x => x.priority == priority)

			for(var i = 0; i < listCheck.length; i++){
				tmpArray.push(0);
				if(listCheck[i].IsVisible_Duyet && listCheck[i].Valid){
					tmpArray[i] = 1;
				}
			}
			let filterCheck = tmpArray.find(x => x == 0);

			if(this.numOfCheckVisible[index][filter] != null && this.numOfCheckVisible[index][filter] != undefined){
				if((filter > -1  && this.numOfCheckVisible[index][filter].value == 0 && filterCheck != null)
				|| (this.numOfCheckVisible[index][filter].value == 1 && this.numOfCheckVisible[index][filter].index == indexDataDuyet)){
					this.numOfCheckVisible[index][filter].value = 1;
					this.numOfCheckVisible[index][filter].index = indexDataDuyet;
					return true;
				}
			}
			
			return false;
		}
	}
	checkEnableButton(data: any, index: number){
		for(var i = 0; i < data.length; i++){
			if(data[i].Title == data[index].Title && data[i].IsEnable_Duyet){
				return false;
			}
		}
		return true;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------ THAY ĐỔI DỮ LIỆU TRÊN LƯỚI ---------------------*/
	canUpdateElementOnGrid(item: any) {
		// if (this.canDeleteOrUpdate(item) && this.isTrueButton(this.SUA))
		// 	return true;
		// return false;
	}
	resetValueUpdate(columnName: string, item: any) {
		if (columnName == 'Sophieu')
			this.deNghiNhapKhoResult[this.deNghiNhapKhoResult.indexOf(item)].Sophieu = this.tmpDeNghiNhapKhoResult[this.deNghiNhapKhoResult.indexOf(item)].Sophieu;
	}
	changeValueOfColumn(columnName: string, item: any, event: any, afterUpdate: boolean) {
		if (columnName == 'Sophieu') {
			if (afterUpdate) {
				this.tmpDeNghiNhapKhoResult[this.deNghiNhapKhoResult.indexOf(item)].Sophieu = item.Sophieu
			}
			else {
				this.deNghiNhapKhoResult[this.deNghiNhapKhoResult.indexOf(item)].Sophieu = event.target.value.trim();
			}
		}
	}
	isChangeValue(columnName: string, item: any) {
		if (columnName == 'Sophieu' && this.deNghiNhapKhoResult[this.deNghiNhapKhoResult.indexOf(item)].Sophieu != this.tmpDeNghiNhapKhoResult[this.deNghiNhapKhoResult.indexOf(item)].Sophieu)
			return true;
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------ CÁC HÀM XÁC NHẬN CẤP QUYỀN ---------------------*/
	isTrueButton(ROLENUMBER: number) {
		if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	isCreate(item:any){
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		let element = this.tmpDeNghiNhapKhoResult.find(x => x.IdDn == item.IdDn);
		if(element != null && (element.Nguoitao == +idUser)){
			return true;
		}
		return false;
	}
	checkShowXacNhan(item: any){
		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		let element = this.tmpDeNghiNhapKhoResult.find(x => x.IdDn == item.IdDn);
		if(element != null){
			let condition = false;
			element.listChiTietNhapKho.forEach(subElement =>{
				if((subElement.PbkiemTraId == +phongban)){
					condition = true;
				}
			})
			return condition;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*----------------------- CSS HIỂN THỊ CHO TRẠNG THAI --------------------*/
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case DeNghiNhapKho.optionsTinhTrang[0].value:
				return this.CONFIG.COLOR_STATE._DangSoanThaoCase;
			case DeNghiNhapKho.optionsTinhTrang[1].value:
				return this.CONFIG.COLOR_STATE._ChoXacNhanXuLyCase;
			case DeNghiNhapKho.optionsTinhTrang[2].value:
				return this.CONFIG.COLOR_STATE._HoanTatCase;
			case DeNghiNhapKho.optionsTinhTrang[3].value:
				return this.CONFIG.COLOR_STATE._HuyCase;
		}
	}
	highlightNewestRecord(item: any) {
		var index = this.deNghiNhapKhoResult.indexOf(item);
		let saveNewIndex = this.saveNewTTHV.indexOf(this.deNghiNhapKhoResult[index].IdDn)
		if (saveNewIndex > -1) {
			this.saveNewTTHV.splice(saveNewIndex, 1)
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*----------------------- CÁC HÀM SỰ KIỆN FOCUS VÀ ROUTE --------------------------*/
	forcusEvents() {
		this.openDialog = false;
		this.changeDetect.detectChanges();
	}
	disabledDialog(){
		this.openDialog = true;
		this.changeDetect.detectChanges();
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
        if(event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.ADD_NEW.KeyCombine.keycode && !this.openDialog) {

			this.openDialog = true;
			this.addPhieuThongTinHangVe();
		}
	}
	checkDashboardRoute() {
		/* 
			Kiểm tra xem có phải đang ở dashboard không, nếu là trang dashboard thì không thực hiện
			các action trên component hiện tại.
		*/
		if (this.router.url === '/')
			return true;
		return false;
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
	/* -----------------------------------------------------------------------*/


	/* ---------- HÀM HỖ TRỢ HIỂN THỊ CỘT TRÊN MENU --------------------------*/
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	/*----------------------------------------------------------------------- */


	/*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/*----------------------------------------------------------------------- */


	/*-----------------------------FILTER ON GRID ----------------------------*/
	removeText(col) {
		this.filterText[col] = "";
		this.loadTTHangVeList();
		this.forcusEvents();
	}

	/* ---------------------------------------------------------------------- */
	//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	// isSelect : true list chon | false là nhap text
	disableDoneButton(col , isSelect = true) {
		let countChecked = 0;
		
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		}else{
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					if(_arrflt.length == 0 && this.filterGroupArray[key].length == 1){
						_arrflt = this.filterGroupArray[key].filter(opt => opt);
					}
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
	}
	filterHead(col, isSelect = true) {
		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);
					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);

				this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadTTHangVeList();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL');
		} else {
			if (this.filterGroupDataCheckedFake) {
				if (!this.filterGroupDataCheckedFake[col]) {
					this.remove('', col, false);
				} else {
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if (this.filterGroupData[col])
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadTTHangVeList();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false);
			this.filterGroupDataCheckedFake[col] = '';
		}
	}
	remove(item, col, isSelect = true) {
		if (isSelect) {
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.loadTTHangVeList();
			}
		} else {
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				this.loadTTHangVeList();
			}
		}
		
		
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.isClearAll = false;
		this.loadTTHangVeList();
		this.forcusEvents();
	}
	checkFilterHasValue(data, col, isSelect = true) {
		
		let _count = 0;
		if(isSelect){
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		}else{
			if(data && data[col] && data[col].length > 0){
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
		
		
		
		
	}
	//#endregion Filter function
}
